<template>
  <div 
    v-if="order" 
    class="container"
  >
    <router-link 
      to="/user/orders"
      :style="{color: '#909399', fontSize: '16px'}"
    >返回我的保單
    </router-link>
    <div :style="{margin: '20px 0'}">
      <p class="tips-primary">
        我們會儘速於1-2日內 (不含假日) 回覆您。<br>若您的問題具時效性，請於上班日（8:00 -18:00）撥打 (02)7707-8987 陳先生，由專人服務，謝謝您
      </p>
    </div>
    <div class="shadow-wrapper comment-board" >
      <div class="comment-board-header">
        <h3
          v-for="(name, i) in insuNames"
          :key="i"
          :style="{marginBottom: '5px'}"
          v-text="name"
        />
        <h3>受理編號： {{ order.orderNo }}</h3>
      </div>
      <div class="comment-board-body">
        <Spin
          v-if="reviewsLoading"
          fix
        />
        <!-- comment group start -->
        <h3
          v-if="!reviews.length"
          class="text-center"
        >目前尚無問題</h3>
        <div
          v-else
          v-for="(review, i) in reviews"
          :key="i"
          class="comment-group"
        >
          <div class="comment-board-comment question clearfix">
            <div class="avatar-wrapper">
              <Avatar :src="require('@/assets/review-avatar.png')" />
            </div>
            <div class="comment-content">
              <span class="time">{{ review.reviewTime.replace(/\s/, '\n') }}</span>
              <span class="main">{{ review.reviewContent }}</span>
            </div>
          </div>
          <template v-for="(reply, i) in review.replys">
            <div
              v-if="reply.value"
              :key="i"
              class="comment-board-comment answer clearfix"
            >
              <div class="avatar-wrapper">
                <Avatar :src="require('@/assets/reply-avatar.png')" />
              </div>
              <div class="comment-content">
                <span class="main">{{ reply.label }}</span>
                <span class="time">{{ reply.value.replace(/\s/, '\n') }}</span>
              </div>
            </div>
          </template>
        </div>
        <!-- comment group end -->
      </div>
      <div class="comment-board-footer">
        <Form
          ref="form"
          v-bind="{model, rules}"
          submit.natvie.prevent
        >
          <BaseTextArea
            v-model="model.content"
            label="問題與建議"
            prop="content"
            :autosize="{minRows: 5 , maxRows: 6}"
          />
          <div class="text-right">
          <Button
            class="btn-m"
            :style="{ marginRight: '15px'}"
            @click="handleReset"
          >重新填寫
          </Button>
          <Button
            class="btn-m btn-primary"
            @click="handleSubmit"
          >確認送出
          </Button>
        </div>
        </Form>
      </div>
    </div>
  </div>
</template>

<script>
  import axios, { generateAuthPostConf } from '@/utils/axios';
  import { Form, Button, Avatar, Spin } from 'iview';
  import BaseTextArea from '@/components/forms/elements/BaseTextArea';
  import { orderType as orderRef } from '@/staticData/textRefs';
  import { SUBMIT_ADVISORY_ACTION } from '@/store/modules/user/constants';

  export default {
    components: { Form, Button, Avatar, BaseTextArea, Spin },
    props: {
      orders: {
        type: Array,
        default: null
      }
    },
    data() {
      return {
        reviewsLoading: false,
        reviews: [],
        model: { content: '' },
        rules: {
          content: { 
            type: 'string',
            required: true,
            trigger: 'blur',
            message: '請輸入您的諮詢內容' 
          }
        }
      };
    },
    computed: {
      order() {
        const { orders, $route } = this;
        const { id } = $route.params;
        return orders.find(o => o.orderId === id);
      },
      insuNames() {
        const { order } = this;
        if (!order) return null;
        const { orderType: type } = order;
        return order.items.map(({ insuName, insuCompany }) => `${insuCompany} ${orderRef[type]} ${insuName}`);
      }
    },
    mounted() {
      if (!this.order) return this.$router.push('/user/orders');
      // const { orderId } = this.order;
      // const config = generateAuthPostConf('Orders/GetOrderInquiries', { orderId });
      // const { data } = await axios(config);
      // const { reviews } = data.result;
      // this.reviewsLoading = false;
      // this.reviews = reviews;
      this.initReviews();
    },
    methods: {
      async handleSubmit() {
        const isValid = await this.$refs.form.validate(v => v);
        if (!isValid) return;
        const { order: { orderId }, model } = this;
        const success = await this.$store.dispatch(SUBMIT_ADVISORY_ACTION, { ...model, orderId });
        if (!success) return;
        this.handleReset();
        this.initReviews();
      },
      handleReset() {
        this.$refs.form.resetFields();
      },
      async initReviews() {
        this.reviewsLoading = true;
        const { orderId } = this.order;
        const config = generateAuthPostConf('Orders/GetOrderInquiries', { orderId });
        const { data } = await axios(config);
        const { reviews } = data.result;
        this.reviewsLoading = false;
        this.reviews = reviews;
      }
    }
  };
</script>

<style lang="scss">
  .comment-board {
    padding: 20px;
    &-body {
      position: relative;
      margin: 20px -20px;
      border-top: 1px solid #ccc;
      border-bottom: 1px solid #ccc;
      padding: 20px;
    }
    &-comment {
      margin-bottom: 20px;
      .avatar-wrapper {
        margin: 0 10px;
      }
      .comment-content {
        position: relative;
        width: 70%;
        .main {
          display: inline-block;
          width: calc(100% - 80px);
          border-radius: 5px;
          padding: 12px;
          font-size: 14px;
        }
        .time {
          position: absolute;
          top: 0;
          white-space: pre;
        }
      }

      &.answer {
        .avatar-wrapper,
        .comment-content {
          float: left;
        }
        .main {
          background: #F8F8F9;
        }
        .time {
          right: 0;
        }
      }

      &.question {
        .avatar-wrapper,
        .comment-content,
        .main {
          float: right;
        }
        .main {
          background: #FFF0EA;
        }
        .time {
          left: 0;
        }
      }
    }
  }
</style>